import CryptoJS from "crypto-js";

export function md5(str) {
    const wordArray = CryptoJS.enc.Utf16LE.parse(str);
    const h = CryptoJS.MD5(wordArray).toString(CryptoJS.enc.Hex).toLowerCase();
    // Apply C# new Guid(byte[]) little-endian byte reordering
    const d1 = h.slice(6, 8) + h.slice(4, 6) + h.slice(2, 4) + h.slice(0, 2);
    const d2 = h.slice(10, 12) + h.slice(8, 10);
    const d3 = h.slice(14, 16) + h.slice(12, 14);
    const d4 = h.slice(16, 20);
    const d5 = h.slice(20, 32);
    return `${d1}-${d2}-${d3}-${d4}-${d5}`;
}
